import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import Button from 'components/ui/Button';

import { ACTION_CODES } from 'constants/errors';
import auth from 'utils/auth';

const ErrorButton = styled(Button)`
  margin: auto;
`;

const P = styled.p`
  color: red;
  font-weight: bold;
  text-align: center;
`;

const goBack = 'errorBoundary.goBack';

const CTAS = {
  [ACTION_CODES.BACK_TO_SEARCH_RESULTS]: (componentInstance) => (
    <ErrorButton data-testid="error-page-cta" onClick={() => componentInstance.setState({ error: null })} id="error-page-cta">
      <FormattedMessage id={goBack} />
    </ErrorButton>
  ),
  [ACTION_CODES.BACK_TO_BOOKING_MAGNET]: (componentInstance) => {
    const { history } = componentInstance.props;

    return (
      <ErrorButton data-testid="error-page-cta" onClick={() => history.push(`/search`)} id="error-page-cta">
        <FormattedMessage id={goBack} />
      </ErrorButton>
    );
  },
  [ACTION_CODES.DEFAULT_ACTION]: (componentInstance, { additionalMessage } = {}) => (
    <>
      {additionalMessage && <P>{additionalMessage}</P>}
      <ErrorButton data-testid="error-page-cta" onClick={() => componentInstance.setState({ error: null })} id="error-page-cta">
        <FormattedMessage id="errorBoundary.tryAgain" />
      </ErrorButton>
    </>
  ),

  [ACTION_CODES.TRANSACTION_PENDING]: () => <div />,
  [ACTION_CODES.REDIRECT_TO_LOGIN_PAGE]: (componentInstance, errorData, nextUrl) => (
    <ErrorButton data-testid="error-page-cta" onClick={() => auth.loginWithNextUrl(errorData.nextUrl || nextUrl)} id="error-page-cta">
      <FormattedMessage id="errorBoundary.login" />
    </ErrorButton>
  ),
  [ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE]: (componentInstance, { errorCTARedirect, ctaText, additionalMessage }) => {
    const { history } = componentInstance.props;

    return (
      <>
        {additionalMessage && <P>{additionalMessage}</P>}
        <ErrorButton data-testid="error-page-cta" onClick={() => history.push(errorCTARedirect)} id="error-page-cta">
          <FormattedMessage id={ctaText || goBack} />
        </ErrorButton>
      </>
    );
  },
  [ACTION_CODES.UPDATE_PASSENGERS_ETAP_ERROR]: (componentInstance, { errorCTARedirect }) => {
    const { history } = componentInstance.props;

    return (
      <>
        <P>There was an issue updating the details in the booking however you will now be able to issue the tickets.</P>
        <ErrorButton data-testid="error-page-cta" onClick={() => history.push(errorCTARedirect)} id="error-page-cta">
          <FormattedMessage id={goBack} />
        </ErrorButton>
      </>
    );
  },
  [ACTION_CODES.REDIRECT_TO_CLUB_EUROSTAR]: (componentInstance, { isWrongAccountLoggedIn } = {}) => {
    const { history } = componentInstance.props;

    return (
      <ErrorButton
        data-testid="error-page-cta"
        onClick={() =>
          history.push(`/clubeurostar/manage`, {
            prevPath: history.location.pathname,
            prevSearch: history.location.search,
            prevHash: history.location.hash
          })
        }
        id="error-page-cta"
      >
        <FormattedMessage id={isWrongAccountLoggedIn ? 'errorBoundary.clubEurostarWrongAccountLoggedIn' : 'errorBoundary.clubEurostar'} />
      </ErrorButton>
    );
  }
};

const getCta = ({ actionCode, errorData }, parent, nextUrl = '/') =>
  (CTAS[actionCode] || CTAS[ACTION_CODES.DEFAULT_ACTION])(parent, errorData || {}, nextUrl);

export { getCta };
